export default __webpack_public_path__ + "static/media/pbi1.68aab616.JPG";